import config from '@/config';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink, Operation } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client';
import { loggingService } from '@/services';
import { setContext } from 'apollo-link-context';
import store from '@/store';
import { BatchHttpLink } from 'apollo-link-batch-http';

export class GraphqlClient {
  public static create(
    httpLinkOptions?: HttpLink.Options,
    withAuth: boolean = false
  ): ApolloClient<NormalizedCacheObject> {
    const httpLinkOption = {
      uri: config.GRAPHQL_ROOT,
      credentials: 'same-origin',
      ...httpLinkOptions
    };
    let links = [onError(loggingService.graphQLErrorHandler)];

    if (withAuth) {
      const authMiddleware = setContext(async request => {
        let token: string;

        // just use current token without validating, since it should be already validated.
        if (request.operationName === 'refresh') {
          token = store.getters.getJwtToken;
        } else {
          token = await store.dispatch('getJwtToken');
        }

        return {
          headers: {
            authorization: token ? `Bearer ${token}` : null
          }
        };
      });
      links.unshift(authMiddleware);
    }

    const client = new ApolloClient({
      link: ApolloLink.from(links).concat(
        ApolloLink.split(
          (operation: Operation) => !operation.getContext().hasUpload,
          new BatchHttpLink({
            uri: config.GRAPHQL_ROOT,
            batchInterval: 50,
            batchMax: 30
          }),
          createUploadLink(httpLinkOption)
        )
      ),
      cache: new InMemoryCache({
        addTypename: false
      }),
      defaultOptions: {
        query: {
          fetchPolicy: 'no-cache'
        },
        watchQuery: {
          fetchPolicy: 'no-cache'
        }
      }
    });

    return client;
  }
}
